import { FC, useState } from "react";
import { Tooltip } from "@material-ui/core";
import style from "./color-picker.module.scss";
import { ColorPicker } from "../color-picker";

export interface ColorPickerToolTipProps {
  onColorSelect(color: string): void;
  selectedColor?: string;
}

export const ColorPickerToolTip: FC<ColorPickerToolTipProps> = ({
  children,
  ...rest
}) => {
  const [showPicker, setShowPicker] = useState(false);

  return (
    <Tooltip
      title={
        <ColorPicker
          showPicker={showPicker}
          setShowPicker={setShowPicker}
          {...rest}
        />
      }
      classes={{ tooltip: style.tooltip }}
      leaveDelay={500}
      interactive
      arrow
    >
      <span>{children}</span>
    </Tooltip>
  );
};
